import { useEffect, useState } from 'react'
import { Row, Col, Card, Divider, Typography, Image } from 'antd';
import escudoIcono from '../img/EscudoIcono.svg';
import CajaIcono from '../img/CajaIcono.svg';
import { ListaProductos } from './ListaProductos.jsx';
import { getDataPedido, getDataDetallePedido } from '../api/pagoPasarela';
import { getProductosDescripciones } from '../api/productoService';
import { createProductosObj, formatDate } from '../utils/helper';
import '../styles/resumenpago.css';

const { Title } = Typography;


export const InformacionPagoCompletado = ({ pedidoPasarelaId, cargoOpenPay }) => {

    const [dataResumenPedido, setDataResumenPedido] = useState([{}, []])
    const [dataCargoOpenPay, setDataCargoOpenPay] = useState({});
    const [time, setTime] = useState(false);
    const [styleResumen, setStyleResumen] = useState({
        overflow: "",
        height: '200px',
        scrollbarGutter: "stable"
    });

    const imgStyles = {
        width: '30px',
        height: '30px',
        paddingBottom: ''
    };

    const styleprecio = {
        textAlign: 'right',
        padding: '0px'
    };

    const styleIconsFooter = {
        aling: 'center',
        paddingTop: '20px'
    };

    const styleDivider = {
        paddingBottom: '0px',
        paddingTop: '0px'
    };

    const timerLoadCar = async () => {
        setTime(true);
        const a = setTimeout(() => {
            setTime(false);
        }, 3000);
        return true;
    }

    useEffect(() => {
        timerLoadCar();
        if (pedidoPasarelaId) {
            getDataResumenPedido(pedidoPasarelaId);
        }
    }, [pedidoPasarelaId]);

    const getDataResumenPedido = async (id) => {
        try {
            let dataPedido = [];
            setDataCargoOpenPay(cargoOpenPay);
            const responseDataPedido = await getDataPedido(id);
            const responseDataPedidoDetalle = await getDataDetallePedido(id);
            const dataPedidoDetalle = responseDataPedidoDetalle.data.data || [];
            dataPedido.push(responseDataPedido.data.data);
            const productosId = dataPedidoDetalle.map(p => p.productoId);
            const detalleproducto = await getProductosDescripciones(productosId);
            const objResumenProducto = await createProductosObj(dataPedidoDetalle, detalleproducto);
            dataPedido.push(objResumenProducto);
            setDataResumenPedido(dataPedido);
        } catch (error) {
            console.error('Error al obtener datos del resumen del pedido:', error);
        }
    }

    if (dataResumenPedido[1].length > 4) {
        styleResumen.overflow = "auto"
    } else {
        styleResumen.overflow = ""
    }

    return (
        <Card
            className="custom-card-width"
            title={`Transaccion Id: ${dataCargoOpenPay?.pagoExternoId} - Fecha: ${formatDate(dataCargoOpenPay?.fechaHoraRegistro)}`}
            bordered={true}
            headStyle={{ 'textAlign': 'center' }}
            bodyStyle={{ 'margin-top': '-24px', 'height': '350px' }}
            loading={time}
            actions={[
                <Row>
                    <Col style={styleIconsFooter} className="gutter-row" xs={{ span: 24, order: 1 }} sm={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }} lg={{ span: 5, offset: 5 }} >
                        <Image
                            preview={false}
                            src={escudoIcono}
                            style={imgStyles}
                        />
                    </Col>
                    <Col className="gutter-row" xs={{ span: 24, order: 1 }} sm={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }} lg={{ span: 8 }} >
                        <p>Garantía 90 días</p>
                    </Col>
                </Row>,
                <Row>
                    <Col style={styleIconsFooter} className="gutter-row" xs={{ span: 24, order: 1 }} sm={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }} lg={{ span: 5, offset: 3 }} >
                        <Image
                            preview={false}
                            src={CajaIcono}
                            style={imgStyles}
                        />
                    </Col>
                    <Col className="gutter-row" xs={{ span: 24, order: 1 }} sm={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }} lg={{ span: 10 }} >
                        <p>Devolución 30 días</p>
                    </Col>
                </Row>
            ]}
        >
            <Col style={styleResumen} className="gutter-row" xs={{ span: 24, order: 1 }} sm={{ span: 24, order: 1 }} md={{ span: 24, order: 1 }} lg={{ span: 24, order: 2 }} >
                <ListaProductos productos={dataResumenPedido[1]} pedidoid={dataResumenPedido[0].pedidoId} sucursalId={dataResumenPedido[0].sucursalId} />
            </Col>
            <Divider style={styleDivider} />
            <Row className='resumenTotal'>
                <Col className="gutter-row" xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 13 }} >
                    <Title level={5} className="custom-title-Total">TOTAL: </Title>
                </Col>
                <Col style={styleprecio} className="gutter-row" xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 11 }} >
                    <Title level={5} className="custom-title-Total">${dataResumenPedido.length > 0 ? dataResumenPedido[0].monto : 0} </Title>
                    <p style={styleprecio} className="custom-title-IVA">MXN/IVA incluido</p>
                </Col>
            </Row>
        </Card>
    )
}
